$(function(){
  $('#menu-bar ul').slicknav();
});

$(document).ready(function() {
 if ($(".sliderMain .slide-img").length>0) {
		$(".sliderMain .slide-img").owlCarousel({
			items : 1,
			itemsCustom : false,
			scrollPerPage: true,
			loop: true,
			slideSpeed: 500,
			stopOnHover: true,
			itemsDesktop : [1199,1],
			itemsDesktopSmall : [991,1],
			itemsTablet: [767,1],
			itemsTabletSmall: false,
			itemsMobile : [479,1],
			itemsScaleUp : true,
			navigation : true,
			pagination : false,
			navigationText : ["prev","next"]

		});
	}
});

$(document).ready(function() {
 if ($(".customer-review .review-list").length>0) {
		$(".customer-review .review-list").owlCarousel({
			items : 1,
			itemsCustom : false,
			scrollPerPage: true,
			loop: true,
			slideSpeed: 500,
			stopOnHover: true,
			itemsDesktop : [1199,1],
			itemsDesktopSmall : [991,1],
			itemsTablet: [767,1],
			itemsTabletSmall: false,
			itemsMobile : [479,1],
			itemsScaleUp : true,
			navigation : true,
			pagination : false,
			navigationText : ["prev","next"]

		});
	}
});
